/* eslint-disable max-lines */
import React, { useState } from 'react';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';
import { SPACES } from 'common/constants/sizes';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';

const GraphWrapper = styled(Flex)`
  border-radius: 5px;
  padding: ${SPACES.medium};
  border: 1px solid ${getColor('catskillWhite')};
  ${({ height }) => `height: ${height};`}
  ${({ cursor }) => `cursor: ${cursor};`}
  ${({ hover }) =>
    hover
      ? `background-color: ${getColor('catskillWhite', 0.4)};`
      : `background-color: ${getColor('white')};`}
`;

export const NewGraphBox = React.forwardRef(({ text }, ref) => {
  const [hover, setIsHover] = useState(false);

  return (
    <GraphWrapper
      height='28rem'
      cursor='pointer'
      isEditable={false}
      justify='center'
      items='center'
      ref={ref}
      data-testid='new-graph-box-wrapper'
      data-cy='new-graph-box-wrapper'
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      hover={hover}
    >
      <Icon name='add' size='medium' color='nepal' />
      <Text pl='small' color='nepal' size='x-x-large'>
        {text}
      </Text>
    </GraphWrapper>
  );
});
